import React, { useEffect } from "react";
import "./TwitterPosts.scss";
import parse from "html-react-parser";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Icon from "../../Elements/Icon/Icon.tsx";

const TwitterPosts = () => {
  const { getTextByKey, getPageText } = useContent();

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="page-container twitter-container">
      <div className="twitter-title-container">
        <h1>
          <b>{getPageText().Display_title && getPageText().Display_title}</b>
        </h1>
        <div className="title-divider"></div>
        {getPageText().TextBox ? parse(getPageText().TextBox) : null}
      </div>
      <div className="twitter-footer-link">
        <a href="https://x.com/jumbomail_me">
          {getTextByKey("follow-us-on")}
          <Icon name="x-twitter" xl blue />
        </a>
      </div>
      <div className="twitter-container">
        <a
          className="twitter-timeline"
          href="https://twitter.com/JumboMail_me?ref_src=twsrc%5Etfw"
        >
          Tweets by JumboMail_me
        </a>
      </div>
      <div className="twitter-footer-link">
        <a href="https://x.com/jumbomail_me">
          {getTextByKey("follow-us-on")}
          <Icon name="x-twitter" xl blue />
        </a>
      </div>
    </div>
  );
};

export default TwitterPosts;
